

<script>
// import VueCharts from 'vue-chartjs'
import {HorizontalBar,mixins} from 'vue-chartjs';
export default {
  name:'HorizontalBarGraph',
  extends: HorizontalBar,
  mixins: [mixins.reactiveProp],
  props: ['chartData', 'options'],
  mounted () {
    // console.log("chart")
    this.renderChart(this.chartData, this.options)
  }
}
</script>